import { inject } from '@angular/core';
import { AjaxService } from 'Angular/services/core/ajax.service';
import { UrlsService } from 'Angular/services/core/urls.service';
import * as i0 from "@angular/core";
export class AgentSuggestedPromptsService {
    constructor() {
        this._ajaxService = inject(AjaxService);
        this._urlsService = inject(UrlsService);
    }
    getSuggestedPrompts(url, pageTitle, source, regenerate = false, currentPrompts = [], pageContext = null) {
        const { path, params } = this._parsePageState(url);
        const body = {
            path,
            params,
            page_title: pageTitle,
            source,
            ...(regenerate ? { regenerate: true, exclude_prompts: currentPrompts } : {}),
            ...(pageContext
                ? {
                    page_content: {
                        app_state_slice_key: pageContext.app_state_slice_key,
                        app_state: pageContext.app_state,
                        dom_snapshot: pageContext.dom_snapshot,
                    },
                }
                : {}),
        };
        return this._ajaxService.postJsonDataObserveBody(this._urlsService.AGENT.SUGGESTED_PROMPTS, body);
    }
    // parse page state from url for certain apps
    _parsePageState(url) {
        const params = {};
        if (!url) {
            return { path: '', params };
        }
        const parsed = new URL(url);
        parsed.searchParams.forEach((value, key) => {
            params[key] = value;
        });
        const hashQueryStart = parsed.hash.indexOf('?');
        if (hashQueryStart !== -1) {
            new URLSearchParams(parsed.hash.slice(hashQueryStart + 1)).forEach((value, key) => {
                params[key] = value;
            });
        }
        return { path: parsed.pathname, params };
    }
}
AgentSuggestedPromptsService.ɵfac = function AgentSuggestedPromptsService_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || AgentSuggestedPromptsService)(); };
AgentSuggestedPromptsService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: AgentSuggestedPromptsService, factory: AgentSuggestedPromptsService.ɵfac, providedIn: 'root' });
